import React, { PureComponent } from 'react';
import { Container } from './elements';
import { LeftSidebarItem } from '../../molecules/LeftSidebarItem';
import { SidebarContents } from '../../molecules/LeftSidebarItem/types';

type Props = {
  sidebarContentsList: Array<SidebarContents>;
  onPressSeeMore: () => void;
};

class LeftSidebar extends PureComponent<Props> {
  renderSidebarItems = () => {
    const { sidebarContentsList = [] } = this.props;
    return sidebarContentsList.map(sidebarContents => (
      <LeftSidebarItem
        {...sidebarContents}
        key={`${sidebarContents.title}_${sidebarContents.link}`}
      />
    ));
  };

  render = (): React.ReactElement => {
    return <Container>{this.renderSidebarItems()}</Container>;
  };
}

export default LeftSidebar;
